//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'ProductDescriptionAndKeywords',
  components: {
    Description: () => import('@motionelements/product2025/src/components/Description.vue'),
  },
  props: {
    description: {
      type: String,
      required: true,
    },
    keywords: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    mediaType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      opened: false,
      height: 'auto',
      minHeight: 80,
      maxHeight: null,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'browser/isMobile',
    }),
  },
  mounted() {
    if (this.isMobile) {
      this.height = `${this.minHeight}px`;
      this.calculateHeight();
    }
    window.addEventListener('resize', this.calculateHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.opened = false;
      const content = document.querySelector('.show-more__content > div');
      this.maxHeight = content.clientHeight;
      this.height = this.isMobile && this.maxHeight > this.minHeight ? `${this.minHeight}px` : 'auto';
    },
    handleShowMore() {
      if (this.opened) {
        this.height = `${this.minHeight}px`;
        this.opened = false;
      } else {
        this.height = `${this.maxHeight}px`;
        this.opened = true;
      }
    },
  },
};
